export default __webpack_public_path__ + "static/media/past-summit-placeholder.9f75b135.svg";